import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hacker-news-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM21.2 229.2H21C21.1 229.1 21.2 228.9 21.3 228.8 21.3 228.9 21.3 229.1 21.2 229.2zM239.2 283.1V384H207.8V281.3L128 128H165.3C217.8 226.3 214.5 229.2 224.6 253.6 236.9 226.6 230.4 229.2 285.2 128H320L239.2 283.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hacker-news-square.js
// module id = FBcb
// module chunks = 144